<ca-icon icon="cross-circle" class="ca-icon-s-16-p-0-f-16 ca-icon-danger"></ca-icon>
<div class="error-message ca-text-sm">
    <ng-content></ng-content>
</div>
